export const queryKeys = {
  auth: ['auth'] as const,
  betaAllowlist: ['admin', 'beta-allowlist'] as const,
  adminAdvices: ['admin', 'advices'] as const,
  adminAdviceCategories: ['admin', 'advice-categories'] as const,
  usersRecent: ['admin', 'users', 'recent'] as const,
  userSearch: (term: string) => ['admin', 'users', term] as const,
  userPhysio: (userId?: string) => ['admin', 'physio', userId] as const,
  trainingPlans: ['admin', 'training-plans'] as const,
  trainingPlan: (uuid?: string) => ['admin', 'training-plan', uuid] as const,
  videos: ['admin', 'videos'] as const,
  stripePlans: ['admin', 'stripe', 'plans'] as const,
  stripeProducts: ['admin', 'stripe', 'products-with-prices'] as const,
  stripeActivePrice: ['admin', 'stripe', 'active-price'] as const,
  stripeOverview: ['admin', 'stripe', 'overview'] as const,
  stripeRevenueTrend: (period: string) => ['admin', 'stripe', 'revenue-trend', period] as const,
  analyticsActiveUsers: ['admin', 'analytics', 'active-users'] as const,
  analyticsRegisteredUsers: ['admin', 'analytics', 'registered-users'] as const,
  analyticsRetention: ['admin', 'analytics', 'retention'] as const,
  analyticsNewVsReturning: ['admin', 'analytics', 'new-vs-returning'] as const,
  analyticsTopEvents: ['admin', 'analytics', 'top-events'] as const,
  analyticsFeatureAdoption: ['admin', 'analytics', 'feature-adoption'] as const,
  analyticsActivationFunnel: ['admin', 'analytics', 'activation-funnel'] as const,
  analyticsCohorts: ['admin', 'analytics', 'cohorts'] as const,
};
